import { render, staticRenderFns } from "./FraudPreventionPolicy.vue?vue&type=template&id=7d216a10&scoped=true"
import script from "./FraudPreventionPolicy.vue?vue&type=script&lang=js"
export * from "./FraudPreventionPolicy.vue?vue&type=script&lang=js"
import style0 from "./FraudPreventionPolicy.vue?vue&type=style&index=0&id=7d216a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d216a10",
  null
  
)

export default component.exports